import type { Product, ProductWithStock } from '../../../domain/models';
import type { BranchInventory } from '../../../domain/models/BranchInventory';

/**
 * Attach branch-scoped stock to a catalog product.
 * Missing BranchInventory → stock/exposé 0 (product still visible everywhere).
 */
export function attachBranchStock(
  product: Product,
  branchId: string,
  inventory?: BranchInventory | null,
): ProductWithStock {
  const exposedOnSite = inventory?.exposedOnSite ?? 0;
  const reservedStock = inventory?.reservedStock ?? 0;
  return {
    ...product,
    branchStock: {
      branchId,
      stock: inventory?.stock ?? 0,
      exposedOnSite,
      reservedStock,
      availableStock: exposedOnSite - reservedStock,
      minimumStock: inventory?.minimumExposed ?? 5,
    },
  };
}

export function inventoryByProductId(
  inventories: BranchInventory[],
): Map<string, BranchInventory> {
  return new Map(inventories.map((inv) => [inv.productId, inv]));
}
